<template>
  <sticky-header-layout>
    <template #header>
      <div class="action-container">
        <span>
          <el-button
            :disabled="isLoading"
            :loading="isSaving"
            class="save-button"
            size="mini"
            type="danger"
            icon="el-icon-upload2"
            @click="handleSave"
          >
            {{ $t('button.save') }}
          </el-button>
        </span>
      </div>
    </template>

    <el-form
      v-loading="isLoading"
      ref="form"
      :disabled="isSaving"
      :model="form"
      class="round-border-form"
      label-position="top"
      label-width="200"
    >
      <template v-for="(search) in form.searches">
        <fieldset :key="search.id">
          <legend>Search</legend>
          <div class="form-group">
            <el-form-item label="Title">
              <el-input
                v-model="search.title"
                clearable
              />
            </el-form-item>
          </div>
          <div class="form-group">
            <el-form-item label="Title ZH-HK">
              <el-input
                v-model="search.title_zh_hk"
                clearable
              />
            </el-form-item>
          </div>
          <div class="form-group">
            <el-form-item label="Title ZH-CN">
              <el-input
                v-model="search.title_zh_cn"
                clearable
              />
            </el-form-item>
          </div>
          <div class="form-group">
            <el-form-item label="Title ZH-TW">
              <el-input
                v-model="search.title_zh_tw"
                clearable
              />
            </el-form-item>
          </div>
          <div class="form-group">
            <el-form-item label="Title TH-TH">
              <el-input
                v-model="search.title_th_th"
                clearable
              />
            </el-form-item>
          </div>
          <div class="form-group">
            <el-form-item label="Link">
              <el-input
                v-model.trim="search.link"
                clearable
              >
                <template slot="prepend">{{ goxipBaseUrl }}</template>
              </el-input>
            </el-form-item>
          </div>
        </fieldset>
      </template>
    </el-form>
  </sticky-header-layout>
</template>

<script>
import { getTrendingSearchDetail, updateTrendingSearch } from '../../api/trendings'

export default {
  name: 'TrendingSearchDetail',
  data() {
    return {
      form: {
        searches: [
          { title: '' },
          { title_zh_hk: '' },
          { title_zh_cn: '' },
          { title_th_th: '' },
          { title_zh_tw: '' },
          { link: '' },
        ],
      },
      isEdited: false,
      isLoading: false,
      isSaving: false,
    }
  },
  computed: {
    goxipBaseUrl() {
      return `${process.env.VUE_APP_GOXIP_BASE_URL}/`
    },
  },
  watch: {
    form: {
      handler() {
        this.isEdited = true
      },
      deep: true,
    },
  },
  mounted() {
    this.getTrendingSearch()
  },
  async beforeRouteLeave(to, from, next) {
    if (this.isSaving) {
      return next(false)
    }

    if (!this.isEdited) {
      return next()
    }

    try {
      await this.$confirm(this.$t('message.leaveWithUnsavedChanges'), this.$t('common.warning'), {
        confirmButtonText: this.$t('button.leave'),
        cancelButtonText: this.$t('button.cancel'),
        type: 'warning',
      })
      return next()
    } catch (error) {
      return next(false)
    }
  },
  methods: {
    async editTrendingSearch(form) {
      this.isSaving = true
      try {
        await updateTrendingSearch(form.searches)
        this.handleSaveSuccess()
      } catch (error) {
        this.handleSaveFail(error)
      }
    },
    async getTrendingSearch() {
      this.isLoading = true
      try {
        const response = await getTrendingSearchDetail()
        if (Array.isArray(response.data)) {
          this.form.searches = response.data
        }

        this.$nextTick(() => {
          this.isEdited = false
          this.isLoading = false
        })
      } catch (error) {
        this.isLoading = false
      }
    },
    handleSaveSuccess() {
      this.isSaving = false
      this.isEdited = false
      // this.goToTrendingTopBrandList()
    },
    handleSaveFail(error) {
      this.isSaving = false
      this.$alert(`Error: ${error}`, this.$t('error.somethingWentWrong'), {
        type: 'error',
        confirmButtonText: 'OK',
      })
    },
    handleValidate() {
      return this.form.searches.every(search => !!(search.title && search.title_zh_hk && search.title_zh_cn && search.title_th_th && search.title_zh_tw))
    },
    handleSave() {
      if (this.handleValidate()) {
        this.editTrendingSearch(this.form)
      } else {
        this.$alert(this.$t('error.pleaseFillInAndCheckErrors'), 'Oops..', {
          confirmButtonText: 'OK',
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";
@import "~@/assets/styles/form.scss";
</style>

<style lang="scss">
.el-form--label-top .el-form-item__label {
  padding: 0;
}
</style>
